"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hashCode;

// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
function hashCode(s) {
  var str = String(s);
  var hash = 0;
  var char;
  if (str.trim().length === 0) return hash;

  for (var i = 0; i < str.length; i++) {
    char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char; // Convert to 32bit integer

    hash &= hash;
  }

  return Math.abs(hash);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hdmF0YXIvc3JjL3V0aWxzL2hhc2guanMiXSwibmFtZXMiOlsiaGFzaENvZGUiLCJzIiwic3RyIiwiU3RyaW5nIiwiaGFzaCIsImNoYXIiLCJ0cmltIiwibGVuZ3RoIiwiaSIsImNoYXJDb2RlQXQiLCJNYXRoIiwiYWJzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDZSxTQUFTQSxRQUFULENBQWtCQyxDQUFsQixFQUFxQjtBQUNsQyxNQUFNQyxHQUFHLEdBQUdDLE1BQU0sQ0FBQ0YsQ0FBRCxDQUFsQjtBQUNBLE1BQUlHLElBQUksR0FBRyxDQUFYO0FBQ0EsTUFBSUMsSUFBSjtBQUNBLE1BQUlILEdBQUcsQ0FBQ0ksSUFBSixHQUFXQyxNQUFYLEtBQXNCLENBQTFCLEVBQTZCLE9BQU9ILElBQVA7O0FBQzdCLE9BQUssSUFBSUksQ0FBQyxHQUFHLENBQWIsRUFBZ0JBLENBQUMsR0FBR04sR0FBRyxDQUFDSyxNQUF4QixFQUFnQ0MsQ0FBQyxFQUFqQyxFQUFxQztBQUNuQ0gsSUFBQUEsSUFBSSxHQUFHSCxHQUFHLENBQUNPLFVBQUosQ0FBZUQsQ0FBZixDQUFQO0FBQ0FKLElBQUFBLElBQUksR0FBRyxDQUFDQSxJQUFJLElBQUksQ0FBVCxJQUFjQSxJQUFkLEdBQXFCQyxJQUE1QixDQUZtQyxDQUduQzs7QUFDQUQsSUFBQUEsSUFBSSxJQUFJQSxJQUFSO0FBQ0Q7O0FBRUQsU0FBT00sSUFBSSxDQUFDQyxHQUFMLENBQVNQLElBQVQsQ0FBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiLy8gaHR0cDovL2VybHljb2Rlci5jb20vNDkvamF2YXNjcmlwdC1oYXNoLWZ1bmN0aW9ucy10by1jb252ZXJ0LXN0cmluZy1pbnRvLWludGVnZXItaGFzaC1cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGhhc2hDb2RlKHMpIHtcbiAgY29uc3Qgc3RyID0gU3RyaW5nKHMpXG4gIGxldCBoYXNoID0gMFxuICBsZXQgY2hhclxuICBpZiAoc3RyLnRyaW0oKS5sZW5ndGggPT09IDApIHJldHVybiBoYXNoXG4gIGZvciAobGV0IGkgPSAwOyBpIDwgc3RyLmxlbmd0aDsgaSsrKSB7XG4gICAgY2hhciA9IHN0ci5jaGFyQ29kZUF0KGkpXG4gICAgaGFzaCA9IChoYXNoIDw8IDUpIC0gaGFzaCArIGNoYXJcbiAgICAvLyBDb252ZXJ0IHRvIDMyYml0IGludGVnZXJcbiAgICBoYXNoICY9IGhhc2hcbiAgfVxuXG4gIHJldHVybiBNYXRoLmFicyhoYXNoKVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/avatar/src/utils/hash.js
// module id = 142
// module chunks = 0